<template>
  <teleport to="body">
    <div class="debug">
      <slot></slot>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "Debug"
};
</script>

<style scoped>
.debug {
  position: relative;
  bottom: 0px;
  width: 100%;
  z-index: 9;
  padding: 1rem;

  font-size: 0.8rem;
  color: darkcyan;
  overflow-wrap: break-word;
  word-wrap: break-word;
  line-height: 1.2rem;
}
</style>
